var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShipping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/24px/Shipping"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#18173C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.2778 16.6127C11.0212 16.3697 10.722 16.1829 10.3952 16.0665L9.71006 13.3986L17.8697 11.1159L18.7438 14.5224L11.2778 16.6127ZM8.68012 9.38794L14.1201 7.86638L14.9948 11.274L9.55537 12.7956L8.68012 9.38794ZM8.92425 16.0153C8.77237 16.0581 8.63119 16.1188 8.49394 16.1858L6.09544 6.83981H5.19319C5.10263 7.03725 4.91306 7.17619 4.68919 7.17619H3.56306C3.252 7.17619 3 6.91237 3 6.58781C3 6.26325 3.252 6 3.56306 6H4.68919C4.87819 6 5.03681 6.1035 5.13919 6.25144H6.87169V6.28012L6.89756 6.27225L9.37819 15.9377C9.22688 15.9517 9.07556 15.9737 8.92425 16.0153ZM9.06994 16.5834C10.1213 16.2893 11.2018 16.9406 11.4836 18.0392C11.7654 19.1366 11.1416 20.265 10.0898 20.5592C9.03844 20.8523 7.95787 20.2009 7.67606 19.1034C7.39425 18.006 8.01863 16.8776 9.06994 16.5834ZM8.7735 18.8351C8.89388 19.3054 9.35738 19.5844 9.80794 19.4578C10.2585 19.3312 10.5257 18.8481 10.4053 18.3778C10.2849 17.9076 9.82144 17.6286 9.37088 17.754C8.91975 17.8806 8.65256 18.3643 8.7735 18.8351ZM18.6735 16.5216L12.1012 18.3598C12.0894 18.2029 12.0675 18.0443 12.027 17.8862C11.9871 17.7281 11.9291 17.5796 11.8644 17.4367L18.4024 15.6086L18.6735 16.5216Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipping);
export default __webpack_public_path__ + "static/media/Shipping.91c3dbfabfc7d516cc2cef5650dab51a.svg";
export { ForwardRef as ReactComponent };